"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AddVIS;

var _react = _interopRequireWildcard(require("react"));

var _button = require("baseui/button");

var _accordion = require("baseui/accordion");

var _reactVis = require("react-vis");

var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));

var _TreeMap = _interopRequireDefault(require("./TreeMap"));

var _utils = require("../utils");

var _JSUtils = require("../JSUtils");

var _SeriesPlot = _interopRequireDefault(require("./showcases/SeriesPlot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VIS = ['Vertical Bar', 'Horizontal Bar', 'Line', 'Pop. Pyramid', 'Treemap'];

function generateVIS(data, column, vis, plotStyle, noLimit, dark) {
  if (!data || data.length === 0 || !(0, _JSUtils.isString)(column) || !(0, _JSUtils.isString)(vis)) {
    return;
  }

  var counts = (0, _utils.xyObjectByProperty)(data, column);

  if (vis === 'Treemap') {
    return _react["default"].createElement(_TreeMap["default"], {
      plotStyle: plotStyle,
      data: {
        title: column + " " + vis,
        color: 1,
        children: counts.map(function (e, i) {
          return {
            name: e.x,
            size: +e.y / data.length,
            color: (0, _JSUtils.isNumber)(e.x) || i,
            style: {
              border: 'thin solid red'
            }
          };
        })
      },
      title: (0, _utils.humanize)(column)
    });
  }

  if (vis.startsWith('Vertical') || vis.startsWith("Horizontal") || vis.startsWith("Line")) {
    return _react["default"].createElement(_SeriesPlot["default"], {
      dark: dark,
      noLimit: noLimit,
      plotStyle: plotStyle,
      data: counts,
      type: vis.startsWith("Vertical") ? _reactVis.VerticalBarSeries : vis.startsWith("Horizontal") ? _reactVis.HorizontalBarSeries : _reactVis.LineSeries,
      title: (0, _utils.humanize)(column),
      noYAxis: true
    });
  }
}

function AddVIS(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      column = _useState2[0],
      setColumn = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      vis = _useState4[0],
      setVis = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      list = _useState6[0],
      setList = _useState6[1];

  var data = props.data,
      _onSelectCallback = props.onSelectCallback,
      dark = props.dark,
      noAccordion = props.noAccordion,
      plotStyle = props.plotStyle,
      noLimit = props.noLimit;
  if (!data || data.length === 0) return null;
  var columns = Object.keys(data[0].properties);
  return _react["default"].createElement("div", null, _react["default"].createElement("h6", null, "Generate graphs from columns"), _react["default"].createElement("div", {
    className: "searchField"
  }, _react["default"].createElement(_MultiSelect["default"], {
    single: true,
    title: "Choose column",
    values: columns.map(function (e) {
      return {
        id: (0, _utils.humanize)(e),
        value: e
      };
    }),
    onSelectCallback: function onSelectCallback(selected) {
      setColumn(selected);
      typeof _onSelectCallback === 'function' && _onSelectCallback(selected);
    },
    value: column
  }), column.length > 0 && _react["default"].createElement(_MultiSelect["default"], {
    single: true,
    title: "Choose vis",
    values: VIS.map(function (e) {
      return {
        id: e,
        value: e
      };
    }),
    onSelectCallback: function onSelectCallback(selected) {
      setVis(selected);
    },
    value: vis
  })), _react["default"].createElement(_button.Button, {
    kind: _button.KIND.secondary,
    size: _button.SIZE.compact,
    onClick: function onClick() {
      if (column.length === 0 || vis.length === 0 || !column[0]) return;
      setList([].concat(_toConsumableArray(list), [generateVIS(data, column[0].value, vis[0].value, plotStyle, dark, noLimit)]));
    }
  }, "Add"), _react["default"].createElement("div", {
    className: "visArea"
  }, !noAccordion ? _react["default"].createElement(_accordion.Accordion, {
    expanded: true,
    onChange: function onChange(_ref) {
      var expanded = _ref.expanded;
      return console.log(expanded);
    }
  }, list.map(function (plot, i) {
    return _react["default"].createElement(_accordion.Panel, {
      key: 'panel-' + i
    }, _react["default"].createElement(_button.Button, {
      kind: _button.KIND.secondary,
      size: _button.SIZE.compact,
      onClick: function onClick() {
        setList(list.filter(function (e, j) {
          return i !== j;
        }));
      }
    }, "X"), plot);
  })) : _react["default"].createElement("center", null, list.map(function (plot, i) {
    return plot && _react["default"].createElement("div", null, _react["default"].createElement(_button.Button, {
      kind: _button.KIND.secondary,
      size: _button.SIZE.compact,
      onClick: function onClick() {
        setList(list.filter(function (e, j) {
          return i !== j;
        }));
      }
    }, "X"), plot);
  }))));
}